module.exports = __webpack_public_path__ + "static/media/drawingPen.bf3d0e11.jpg";